import React from 'react';
import WishlistItem from './WishlistItem';
import EmptyState from '../common/EmptyState';
import { HeartIcon } from '../icons/Icons';
import Button from '../common/Button';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../config/theme';

const WishlistGrid = ({ items, loading }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div style={{ padding: theme.spacing['3xl'], textAlign: 'center' }}>
        Loading wishlist...
      </div>
    );
  }

  if (!items || items.length === 0) {
    return (
      <EmptyState
        icon={<HeartIcon size={64} />}
        title="Your wishlist is empty"
        description="Save items you love to view them later"
        action={
          <Button 
            variant="primary"
            size="md"
            onClick={() => navigate('/products')}
          >
            Browse Products
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ display: 'grid', gap: theme.spacing.md }}>
      {items.map((item) => (
        <WishlistItem key={item.id} item={item} />
      ))}
    </div>
  );
};

export default WishlistGrid;